export default (items, on, toggle) => {
  if (on || !items) return

  toggle()
}
